module.exports = __webpack_public_path__ + "assets/img/newimgdj.345fbea0.png";